!(function () {
   const cookiebot_cookie_name = 'CookieConsent';
   const read_cookie = (key) => {
      try {
         let x = key + '=';
         if (document.cookie.includes(x) === false) return null;
         for (let cookie of document.cookie.split(';')) {
            cookie = cookie.trim();
            if (cookie.startsWith(x)) return cookie.replace(x, '').trim();
         }
         return null;
      } catch (e) {
         console.log(e);
         return null;
      }
   };

   const update_consent_status = () => {
      if (!window.Shopify || !window.Shopify.customerPrivacy) {
         console.log('Customer privacy was not found');
         return;
      }
      const status = read_cookie(cookiebot_cookie_name);

      window.Shopify.customerPrivacy.setTrackingConsent({
         analytics: !status ? false : status.includes(`statistics:true`),
         marketing: !status ? false : status.includes(`marketing:true`),
         preferences: !status ? false : status.includes(`preferences:true`),
         sale_of_data: !status ? false : status.includes(`marketing:true`)
      });
   };

   // Activate consent tracking API
   window.Shopify.loadFeatures(
      [
         {
            name: 'consent-tracking-api',
            version: '0.1'
         }
      ],
      function (error) {
         if (error) {
            console.log(error);
            return;
         }
         update_consent_status();
      }
   );

   const handle_event = (e) => {
      const timeout = setTimeout(() => {
         update_consent_status(), clearTimeout(timeout);
      }, 100);
   };

   // On cookiebot initialize
   window.addEventListener('CookiebotOnConsentReady', handle_event);

   // On consent status change
   window.addEventListener('CookiebotOnAccept', handle_event);
   window.addEventListener('CookiebotOnDecline', handle_event);

   // Handle renew consent link
   const handle_renew_consent = (e) => {
      if (e.target.matches('a[href="#cookiebot_renew_consent"]')) {
         e.preventDefault();
         if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
            window.Cookiebot.renew();
         } else {
            console.warn('Cookiebot.renew() ist nicht verfügbar');
         }
      }
   };

   // Event-Listener für Clicks auf den Renew-Link
   document.addEventListener('click', handle_renew_consent);

   // Falls der Link schon beim Laden der Seite vorhanden ist
   document.addEventListener('DOMContentLoaded', () => {
      const renewLinks = document.querySelectorAll('a[href="#cookiebot_renew_consent"]');
      renewLinks.forEach(link => {
         link.addEventListener('click', (e) => {
            e.preventDefault();
            if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
               window.Cookiebot.renew();
            } else {
               console.warn('Cookiebot.renew() ist nicht verfügbar');
            }
         });
      });
   });
})(0);